import React from 'react'

const ContactBranches = props => {
  return (
    <secion className="contact-branches">
      <div className="container">
        <div className="row">
          {props.data &&
            props.data.map(element => {
              return (
                <>
                  {element.header && (
                    <div className="col-12">
                      <h3>{element.header}</h3>
                    </div>
                  )}
                  <div
                    className="col-lg-3"
                    dangerouslySetInnerHTML={{ __html: element.text }}
                  />
                </>
              )
            })}
        </div>
      </div>
    </secion>
  )
}

export default ContactBranches
